export default __webpack_public_path__ + "4edddaa088aa0b1f49a8f7914549a6ea.jpg";